import { authContractLimits } from '../constants/contractLimits'
import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, validatePasswordComplexity } from './passwordValidation'
import type { BootstrapPayload, ResetPasswordPayload } from '../types/auth'

export const AUTH_CONTRACT_LIMITS = {
  ...authContractLimits,
  passwordMinLength: PASSWORD_MIN_LENGTH,
  passwordMaxLength: PASSWORD_MAX_LENGTH
} as const

interface PasswordFieldHtmlInputOptions {
  includeMinLength?: boolean
}

interface ConfirmedPasswordValidationOptions {
  requiredMessage?: string
  mismatchMessage?: string
}

export function getPasswordFieldHtmlInputProps(
  { includeMinLength = true }: PasswordFieldHtmlInputOptions = {}
): { minLength?: number; maxLength: number } {
  return includeMinLength
    ? { minLength: AUTH_CONTRACT_LIMITS.passwordMinLength, maxLength: AUTH_CONTRACT_LIMITS.passwordMaxLength }
    : { maxLength: AUTH_CONTRACT_LIMITS.passwordMaxLength }
}

export function validateConfirmedPassword(
  password: string | null | undefined,
  confirmPassword: string | null | undefined,
  {
    requiredMessage = 'Введите новый пароль.',
    mismatchMessage = 'Пароль и подтверждение не совпадают.'
  }: ConfirmedPasswordValidationOptions = {}
): string | null {
  const normalizedPassword = password ?? ''
  const normalizedConfirmPassword = confirmPassword ?? ''

  if (!normalizedPassword) {
    return requiredMessage
  }

  if (normalizedPassword !== normalizedConfirmPassword) {
    return mismatchMessage
  }

  return validatePasswordComplexity(normalizedPassword)
}

export function validateBootstrapForm(payload: BootstrapPayload): string | null {
  return validateConfirmedPassword(payload.password, payload.confirmPassword, {
    requiredMessage: 'Пароль обязателен.',
    mismatchMessage: 'Пароли не совпадают.'
  })
}

export function validateResetPasswordForm(payload: ResetPasswordPayload): string | null {
  return validateConfirmedPassword(payload.newPassword, payload.confirmNewPassword, {
    requiredMessage: 'Введите новый пароль.',
    mismatchMessage: 'Пароли не совпадают.'
  })
}
